module.exports = __webpack_public_path__ + "static/media/pic3.d7e0c4cc.jpg";